// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-cart {
  position: fixed;
  top: 98px;
  right: 0;
  left: 0;
  bottom: 0;
  max-width: 100%;
  height: auto;
  max-height: calc(100% - 98px);
  background-color: rgb(233, 231, 222);
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  padding: 20px 10px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.popup-cart__heading {
  align-self: center;
  margin: 0;
}

.popup-cart__adress {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: auto auto auto;
  column-gap: 10px;
  row-gap: 10px;
}
  
.popup-cart__adress-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid rgb(122,148,90);
  border-radius: 5px;
  font-size: 10px;
  padding: 3px 10px 0;
}
  
.popup-cart__adress-item input,select, textarea {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: rgb(75, 70, 70);
  line-height: 16px;
  border-style: none;
  background-color: rgb(233, 231, 222);
}
  
.popup-cart__adress-item input, textarea, select:focus {
  outline: none;
}
  
.popup-cart__adress-item1 {
  grid-column: span 5;
}
 
.popup-cart__adress-item2 {
  grid-column: span 5;
  position: relative;
}
  
.popup-cart__adress-item3,
.popup-cart__adress-item4,
.popup-cart__adress-item5,
.popup-cart__adress-item6,
.popup-cart__adress-item7 {
  grid-column: span 2;
}
  
.popup-cart__adress-item8 {
  grid-row: 3;
  grid-column: 1 / -1;
}

.popup-cart__adress-item2-dropdown {
  width: 100%;
}

.popup-cart__adress-item2 select {
  height: 200px;
}

.popup-cart__total {
  width: 100%;
  max-width: 1130px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
  
.popup-cart__spoons {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.popup-cart__button-plus{
  position: relative;
  width: 22px;
  height: 22px;
  border: 2px solid rgb(122,148,90);
  background-color: #f0f0f0;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 5px;
}

.popup-cart__button-plus-plus::before {
  width: 60%;
  height: 3px;
}

.popup-cart__button-plus-plus::after {
  width: 3px;
  height: 60%;
}

.popup-cart__button-plus-minus::before {
  width: 60%;
  height: 4px;
}

.popup-cart__button-plus-minus::after {
  display: none;
}

.popup-cart__button-plus:hover::before,
.popup-cart__button-plus:hover::after {
  background-color: #ff5722;
}

.popup-cart__button-order {
  width: 100%;
  max-width: 1130px;
  font-size: 18px;
  color: rgb(208,205,193);
  border: none;
  background: rgb(122,148,90);
  border-radius: 5px;
  padding: 10px 50px;
  cursor: pointer;
}

.popup-cart__button-order:hover {
  opacity: .8;
}

.popup-cart__button-add {
  padding: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  color: rgb(208,205,193);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  animation: blink 5s infinite;
}

@keyframes blink {
  0%, 100% {
    background-color: rgb(211, 221, 200);
    color: rgb(75, 70, 70);
  }
  50% {
    background-color: rgb(122,148,90);
    color: rgb(208,205,193);
  }
}

.popup-cart__button-add:hover {
  opacity: .8;
}

.popup-cart__products {
  max-width: 1130px;
  list-style: none;
  padding: 0;
}
  
.popup-cart__product {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: auto auto;
  column-gap: 10px;
  row-gap: 10px;
  align-items: center;
  background-color: rgb(211, 221, 200);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}
  
.popup-cart__product1 {
  grid-column: span 1;
  width: 130px;
  height: 100px;
  object-fit: cover;
  border-radius: 5px;
}

.popup-cart__product2 {
  grid-column: span 2;
}

.popup-cart__product3 {
  grid-column: span 1;
}

.popup-cart__product4 {
  grid-column: span 1;
  text-align: center;
}

.popup-cart__product5 {
  grid-column: 6 / -1;
}

.popup-cart__product5 textarea {
  background-color: rgb(211, 221, 200);
}

.popup-cart__product6 {
  grid-row: 2;
  grid-column: 1 / -1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
}

.popup-cart__product6 li {
  border: solid 1px rgb(122,148,90);
  border-radius: 5px;
  padding: 3px;
}

.popup-cart__button-remove {
  position: relative;
  width: 22px;
  height: 22px;
  border: 2px solid rgb(122,148,90);
  background-color: #f0f0f0;
  border-radius: 5px;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px 0;
}

.popup-cart__button-remove::before,
.popup-cart__button-remove::after {
  content: '';
  position: absolute;
  width: 60%;
  height: 3px;
  background-color: rgb(122,148,90);
  transition: background-color 0.3s ease;
}

.popup-cart__button-remove::before {
  transform: rotate(45deg);
}

.popup-cart__button-remove::after {
  transform: rotate(-45deg);
}
  
.popup-cart__button-remove:hover::before,
.popup-cart__button-remove:hover::after {
  background-color: #ff5722;
}

.popup-cart__pizza-box {
  margin-top: 20px;
}

@media screen and (max-width: 910px) {
  .popup-cart {
    top: 92px;
    max-height: calc(100% - 92px);
  }

  .popup-cart__adress-item1 {
    grid-row: 1;
    grid-column: 1 / -1;
  }

  .popup-cart__adress-item2 {
    grid-row: 2;
    grid-column: 1 / -1;
  }

  .popup-cart__adress-item8 {
    grid-row: 4;
    grid-column: 1 / -1;
  }

  .popup-cart__total {
    flex-direction: column;
    gap: 10px;
    align-items: start;
  }

  .popup-cart__product {
    grid-template-rows: auto auto auto;
  }

  .popup-cart__product2 {
    grid-column: 2 / 6;
    margin: 0;
  }

  .popup-cart__product4 {
    grid-column: 7 / -1;
    margin: 0;
  }

  .popup-cart__product5 {
    grid-row: 3;
    grid-column: 1 / -1;
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 520px) {
  .popup-cart {
    top: 79px;
    max-height: calc(100% - 79px);
  }

  .popup-cart__heading_little {
    font-size: 14px;
  }

  .popup-cart__product1 {
    grid-column: 1 / -1;
    width: 100%;
    height: 100px;
  }

  .popup-cart__product2 {
    grid-row: 2;
    grid-column: 1 / 6;
  }

  .popup-cart__product3 {
    grid-row: 2;
    grid-column: 6 / 7;
  }

  .popup-cart__product4 {
    grid-row: 2;
    grid-column: 7 / -1;
  }

  .popup-cart__product5 {
    grid-row: 4;
    grid-column: 1 / -1;
  }

  .popup-cart__product6 {
    grid-row: 3;
    grid-column: 1 / -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PopupCart.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,OAAO;EACP,SAAS;EACT,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;EAKE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE;IACE,oCAAoC;IACpC,sBAAsB;EACxB;EACA;IACE,iCAAiC;IACjC,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF","sourcesContent":[".popup-cart {\r\n  position: fixed;\r\n  top: 98px;\r\n  right: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  max-width: 100%;\r\n  height: auto;\r\n  max-height: calc(100% - 98px);\r\n  background-color: rgb(233, 231, 222);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  align-items: center;\r\n  padding: 20px 10px;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n.popup-cart__heading {\r\n  align-self: center;\r\n  margin: 0;\r\n}\r\n\r\n.popup-cart__adress {\r\n  display: grid;\r\n  grid-template-columns: repeat(10, 1fr);\r\n  grid-template-rows: auto auto auto;\r\n  column-gap: 10px;\r\n  row-gap: 10px;\r\n}\r\n  \r\n.popup-cart__adress-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  border: 1px solid rgb(122,148,90);\r\n  border-radius: 5px;\r\n  font-size: 10px;\r\n  padding: 3px 10px 0;\r\n}\r\n  \r\n.popup-cart__adress-item input,select, textarea {\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  font-size: 16px;\r\n  color: rgb(75, 70, 70);\r\n  line-height: 16px;\r\n  border-style: none;\r\n  background-color: rgb(233, 231, 222);\r\n}\r\n  \r\n.popup-cart__adress-item input, textarea, select:focus {\r\n  outline: none;\r\n}\r\n  \r\n.popup-cart__adress-item1 {\r\n  grid-column: span 5;\r\n}\r\n \r\n.popup-cart__adress-item2 {\r\n  grid-column: span 5;\r\n  position: relative;\r\n}\r\n  \r\n.popup-cart__adress-item3,\r\n.popup-cart__adress-item4,\r\n.popup-cart__adress-item5,\r\n.popup-cart__adress-item6,\r\n.popup-cart__adress-item7 {\r\n  grid-column: span 2;\r\n}\r\n  \r\n.popup-cart__adress-item8 {\r\n  grid-row: 3;\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.popup-cart__adress-item2-dropdown {\r\n  width: 100%;\r\n}\r\n\r\n.popup-cart__adress-item2 select {\r\n  height: 200px;\r\n}\r\n\r\n.popup-cart__total {\r\n  width: 100%;\r\n  max-width: 1130px;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n  \r\n.popup-cart__spoons {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 20px;\r\n}\r\n\r\n.popup-cart__button-plus{\r\n  position: relative;\r\n  width: 22px;\r\n  height: 22px;\r\n  border: 2px solid rgb(122,148,90);\r\n  background-color: #f0f0f0;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 5px;\r\n}\r\n\r\n.popup-cart__button-plus-plus::before {\r\n  width: 60%;\r\n  height: 3px;\r\n}\r\n\r\n.popup-cart__button-plus-plus::after {\r\n  width: 3px;\r\n  height: 60%;\r\n}\r\n\r\n.popup-cart__button-plus-minus::before {\r\n  width: 60%;\r\n  height: 4px;\r\n}\r\n\r\n.popup-cart__button-plus-minus::after {\r\n  display: none;\r\n}\r\n\r\n.popup-cart__button-plus:hover::before,\r\n.popup-cart__button-plus:hover::after {\r\n  background-color: #ff5722;\r\n}\r\n\r\n.popup-cart__button-order {\r\n  width: 100%;\r\n  max-width: 1130px;\r\n  font-size: 18px;\r\n  color: rgb(208,205,193);\r\n  border: none;\r\n  background: rgb(122,148,90);\r\n  border-radius: 5px;\r\n  padding: 10px 50px;\r\n  cursor: pointer;\r\n}\r\n\r\n.popup-cart__button-order:hover {\r\n  opacity: .8;\r\n}\r\n\r\n.popup-cart__button-add {\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  font-size: 16px;\r\n  color: rgb(208,205,193);\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  animation: blink 5s infinite;\r\n}\r\n\r\n@keyframes blink {\r\n  0%, 100% {\r\n    background-color: rgb(211, 221, 200);\r\n    color: rgb(75, 70, 70);\r\n  }\r\n  50% {\r\n    background-color: rgb(122,148,90);\r\n    color: rgb(208,205,193);\r\n  }\r\n}\r\n\r\n.popup-cart__button-add:hover {\r\n  opacity: .8;\r\n}\r\n\r\n.popup-cart__products {\r\n  max-width: 1130px;\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n  \r\n.popup-cart__product {\r\n  display: grid;\r\n  grid-template-columns: repeat(8, 1fr);\r\n  grid-template-rows: auto auto;\r\n  column-gap: 10px;\r\n  row-gap: 10px;\r\n  align-items: center;\r\n  background-color: rgb(211, 221, 200);\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n  margin-bottom: 10px;\r\n}\r\n  \r\n.popup-cart__product1 {\r\n  grid-column: span 1;\r\n  width: 130px;\r\n  height: 100px;\r\n  object-fit: cover;\r\n  border-radius: 5px;\r\n}\r\n\r\n.popup-cart__product2 {\r\n  grid-column: span 2;\r\n}\r\n\r\n.popup-cart__product3 {\r\n  grid-column: span 1;\r\n}\r\n\r\n.popup-cart__product4 {\r\n  grid-column: span 1;\r\n  text-align: center;\r\n}\r\n\r\n.popup-cart__product5 {\r\n  grid-column: 6 / -1;\r\n}\r\n\r\n.popup-cart__product5 textarea {\r\n  background-color: rgb(211, 221, 200);\r\n}\r\n\r\n.popup-cart__product6 {\r\n  grid-row: 2;\r\n  grid-column: 1 / -1;\r\n  display: flex;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  list-style: none;\r\n}\r\n\r\n.popup-cart__product6 li {\r\n  border: solid 1px rgb(122,148,90);\r\n  border-radius: 5px;\r\n  padding: 3px;\r\n}\r\n\r\n.popup-cart__button-remove {\r\n  position: relative;\r\n  width: 22px;\r\n  height: 22px;\r\n  border: 2px solid rgb(122,148,90);\r\n  background-color: #f0f0f0;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 0 10px 0;\r\n}\r\n\r\n.popup-cart__button-remove::before,\r\n.popup-cart__button-remove::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 60%;\r\n  height: 3px;\r\n  background-color: rgb(122,148,90);\r\n  transition: background-color 0.3s ease;\r\n}\r\n\r\n.popup-cart__button-remove::before {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.popup-cart__button-remove::after {\r\n  transform: rotate(-45deg);\r\n}\r\n  \r\n.popup-cart__button-remove:hover::before,\r\n.popup-cart__button-remove:hover::after {\r\n  background-color: #ff5722;\r\n}\r\n\r\n.popup-cart__pizza-box {\r\n  margin-top: 20px;\r\n}\r\n\r\n@media screen and (max-width: 910px) {\r\n  .popup-cart {\r\n    top: 92px;\r\n    max-height: calc(100% - 92px);\r\n  }\r\n\r\n  .popup-cart__adress-item1 {\r\n    grid-row: 1;\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  .popup-cart__adress-item2 {\r\n    grid-row: 2;\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  .popup-cart__adress-item8 {\r\n    grid-row: 4;\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  .popup-cart__total {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    align-items: start;\r\n  }\r\n\r\n  .popup-cart__product {\r\n    grid-template-rows: auto auto auto;\r\n  }\r\n\r\n  .popup-cart__product2 {\r\n    grid-column: 2 / 6;\r\n    margin: 0;\r\n  }\r\n\r\n  .popup-cart__product4 {\r\n    grid-column: 7 / -1;\r\n    margin: 0;\r\n  }\r\n\r\n  .popup-cart__product5 {\r\n    grid-row: 3;\r\n    grid-column: 1 / -1;\r\n    margin-bottom: 20px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .popup-cart {\r\n    top: 79px;\r\n    max-height: calc(100% - 79px);\r\n  }\r\n\r\n  .popup-cart__heading_little {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .popup-cart__product1 {\r\n    grid-column: 1 / -1;\r\n    width: 100%;\r\n    height: 100px;\r\n  }\r\n\r\n  .popup-cart__product2 {\r\n    grid-row: 2;\r\n    grid-column: 1 / 6;\r\n  }\r\n\r\n  .popup-cart__product3 {\r\n    grid-row: 2;\r\n    grid-column: 6 / 7;\r\n  }\r\n\r\n  .popup-cart__product4 {\r\n    grid-row: 2;\r\n    grid-column: 7 / -1;\r\n  }\r\n\r\n  .popup-cart__product5 {\r\n    grid-row: 4;\r\n    grid-column: 1 / -1;\r\n  }\r\n\r\n  .popup-cart__product6 {\r\n    grid-row: 3;\r\n    grid-column: 1 / -1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
